import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-minus-circle",
  templateUrl: "./med-icon-minus-circle.component.html",
})
export class MedIconMinusCircleComponent extends SvgMixinComponent {}
